import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { PARTNER_INFO_FIELDS } from './UserProfileWidgetPartnerInfo.constants'

function UserProfileWidgetPartnerInfo({
  canEdit,
  data,
  fieldVariables,
  isSkeleton,
  options,
  onClickEmail,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={PARTNER_INFO_FIELDS}
      data={data}
      fieldVariables={fieldVariables}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.PartnerInfoTitleKey')}
      onClickEmail={onClickEmail}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetPartnerInfo
